import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { BookV1 } from '@ilteducation/content-registry-types';
import useUploadMedia from '@/comp/use-upload-media';
import DropFile from '@/components/base/DropFile.vue';
import { downloadExternalContent } from '@/data-provider/refDataProvider';
import eventBus from '@/foundations/services/eventBus';
import DisableableButton from '../buttons/DisableableButton.vue';

type Props = {
  id: string;
  item: BookV1;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FrontCoverUploader',
  props: {
    id: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  item: BookV1;
}



const { uploadInProgress, upload } = useUploadMedia();

const file = ref<File[]>([]);
const isChanged = ref(false);

const uploadCover = () => {
  upload(props.item.id, file.value[0], { subType: 'bookCover' });
};

const changeHandler = (inputFile: File[]) => {
  if (!inputFile || !inputFile.length) {
    isChanged.value = false;
    return;
  }

  isChanged.value = true;
  file.value = inputFile;
};

const showUploadDialog = ref<boolean>(false);
const coverUrl = ref<string>('');

const canDownloadExternalCover = ref(false);
const checkingIfCanDownloadExternalCover = ref(false);
/**
 * Check if the cover is available for download via BokInfo
 */
const checkCanDownloadExternalCover = async () => {
  checkingIfCanDownloadExternalCover.value = true;
  if (props.item?.isbn) {
    const urlObj = await downloadExternalContent(props.item.isbn, 'cover', props.id);
    if (urlObj) {
      canDownloadExternalCover.value = urlObj.url.length > 0;
      coverUrl.value = urlObj.url;
      showUploadDialog.value = true;
    } else {
      eventBus.$emit('snackbar.open', 'No cover found');
    }
  }
  checkingIfCanDownloadExternalCover.value = false;
};

const uploadCoverFromUrl = async () => {
  const urlObj = await downloadExternalContent(props.item.isbn, 'cover', props.id, false);
  eventBus.$emit('snackbar.open', urlObj?.status);
  showUploadDialog.value = false;
};

return { __sfc: true,props, uploadInProgress, upload, file, isChanged, uploadCover, changeHandler, showUploadDialog, coverUrl, canDownloadExternalCover, checkingIfCanDownloadExternalCover, checkCanDownloadExternalCover, uploadCoverFromUrl, DropFile, DisableableButton }
}

})